<template>
  <svg class="icon" aria-hidden="true">
    <use :xlink:href="iconName"></use>
    <slot></slot>
  </svg>
</template>
<script>
export default {
  name: 'IIcon',
  props: ['name'],
  computed: {
    iconName() {
      return `#icon-${this.name}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/IIcon.vue